import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import styled from '@emotion/styled';
import { useState } from 'react';
import BookDemo from './BookDemo';

const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  margin-top: 80px;
  
  img {
    max-width: 100%;
    height: auto;
  }

  .wp-block-cover {
    position: relative;
    padding: 2rem;
    margin: -2rem -2rem 2rem -2rem;
    max-width: none;
    width: calc(100% + 4rem);

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      z-index: 1;
    }

    .wp-block-cover__inner-container {
      position: relative;
      z-index: 2;
      color: white;
    }
  }

  @media (max-width: 768px) {
    margin-top: 60px;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
`;

const ErrorContainer = styled.div`
  text-align: center;
  padding: 2rem;
  color: red;
`;

function WordPressPage() {
  const { slug } = useParams<{ slug: string }>();
  const [isDemoOpen, setIsDemoOpen] = useState(false);

  const { data: page, isLoading, error } = useQuery({
    queryKey: ['page', slug],
    queryFn: async () => {
      const response = await fetch(`https://ggtude.com/wp-json/wp/v2/pages?slug=${slug}`);
      if (!response.ok) throw new Error('Failed to fetch page');
      const pages = await response.json();
      if (pages.length === 0) throw new Error('Page not found');
      return pages[0];
    }
  });

  if (isLoading) {
    return (
      <>
        <LoadingContainer>Loading...</LoadingContainer>
        <BookDemo isOpen={isDemoOpen} onClose={() => setIsDemoOpen(false)} />
      </>
    );
  }

  if (error) {
    return (
      <>
        <ErrorContainer>
          <h1>Error</h1>
          <p>{error instanceof Error ? error.message : 'Failed to load page'}</p>
        </ErrorContainer>
        <BookDemo isOpen={isDemoOpen} onClose={() => setIsDemoOpen(false)} />
      </>
    );
  }

  return (
    <>
      <PageContainer>
        <div dangerouslySetInnerHTML={{ __html: page.content.rendered }} />
      </PageContainer>
      <BookDemo isOpen={isDemoOpen} onClose={() => setIsDemoOpen(false)} />
    </>
  );
}

export default WordPressPage; 